export default "__VITE_ASSET__eb2e709a__"